import { render, staticRenderFns } from "./ModalInsercaoArquivoNotaDePesagem.vue?vue&type=template&id=60734f08&lang=pug"
import script from "./ModalInsercaoArquivoNotaDePesagem.vue?vue&type=script&lang=js"
export * from "./ModalInsercaoArquivoNotaDePesagem.vue?vue&type=script&lang=js"
import style0 from "./ModalInsercaoArquivoNotaDePesagem.vue?vue&type=style&index=0&id=60734f08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports